import { apiFetch } from "../utils/apiFetch"

export type PowerOfAttorneyKind = "trademark" | "design" | "patent"

export type UploadedPowerOfAttorney = {
  fileName: string
  uploadedAt: string
  // Only sent to admins
  patOrgStatus?: "SYNCED" | "SKIPPED" | "ERROR"
  patOrgMessage?: string | null
}

export type PowerOfAttorneyStatus = { uploaded: UploadedPowerOfAttorney | null }

const base = (kind: PowerOfAttorneyKind, applicationId: string) =>
  `/api/power-of-attorney/${kind}/${applicationId}`

export function getPowerOfAttorneyStatus(kind: PowerOfAttorneyKind, applicationId: string) {
  return apiFetch(base(kind, applicationId)) as Promise<PowerOfAttorneyStatus>
}

export function uploadPowerOfAttorney(
  kind: PowerOfAttorneyKind,
  applicationId: string,
  file: File
) {
  const formData = new FormData()
  formData.append("file", file)

  return apiFetch(base(kind, applicationId), {
    method: "POST",
    body: formData
  }) as Promise<PowerOfAttorneyStatus>
}

// The pre-filled power of attorney (template) or the uploaded one, as a file
function downloadPdf(path: string, fileName: string) {
  return apiFetch(path, {}, "blob").then((blob: Blob) => {
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  })
}

export function downloadPowerOfAttorneyTemplate(kind: PowerOfAttorneyKind, applicationId: string) {
  return downloadPdf(`${base(kind, applicationId)}/template`, "Vollmacht.pdf")
}

export function downloadUploadedPowerOfAttorney(
  kind: PowerOfAttorneyKind,
  applicationId: string,
  fileName: string
) {
  return downloadPdf(`${base(kind, applicationId)}/file`, fileName)
}
